<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="!item['@id']">
          <v-file-input
            v-model="item.file"
            accept=".fff"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.public') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.experimental') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.experimental"
                :error-messages="experimentalErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--<v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.newrelease') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.newRelease"
                :error-messages="newReleaseErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.updaterelease') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.updateRelease"
                :error-messages="updateReleaseErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>-->
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareSelectItems"
            v-model="item.softwares"
            :items="softwareSelectItems"
            :error-messages="softwaresErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.software.softwares')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machines"
            :items="machineSelectItems"
            :error-messages="machinesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.machines')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolheadSelectItems"
            v-model="item.toolheads"
            :items="toolheadSelectItems"
            :error-messages="toolheadsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.toolheads')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.options"
            :items="optionSelectItems"
            :error-messages="optionsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.options')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="surfaceSelectItems"
            v-model="item.surfaces"
            :items="surfaceSelectItems"
            :error-messages="surfacesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.printingsurface.printingsurfaces')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialtypeSelectItems"
            v-model="item.materialType"
            :items="materialtypeSelectItems"
            :error-messages="materialtypeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.material.types')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialmanufacturerSelectItems"
            v-model="item.materialManufacturer"
            :items="materialmanufacturerSelectItems"
            :error-messages="materialManufacturerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.material.manufacturer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="colorSelectItems"
            v-model="item.colors"
            :items="colorSelectItems"
            :error-messages="colorsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.material.colors')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="qualitySelectItems"
            v-model="item.qualities"
            :items="qualitySelectItems"
            :error-messages="qualitiesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.quality.qualities')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleMaterialSelectItems"
            v-model="item.nozzleMaterials"
            :items="nozzleMaterialSelectItems"
            :error-messages="nozzleMaterialsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.nozzle.materials')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleSelectItems"
            v-model="item.nozzles"
            :items="nozzleSelectItems"
            :error-messages="nozzlesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.quality.nozzlesout')"
            item-text="size"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="layerSelectItems"
            v-model="item.layers"
            :items="layerSelectItems"
            :error-messages="layersErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.quality.layers')"
            item-text="height"
            item-value="@id"
            :search-input.sync="search"
            chips
            persistent-hint
            @change="changeLayer()"
          >
        <template v-slot:no-data>
                   <v-list-item>
                     <v-list-item-content>
                       <v-list-item-title>
                         {{ $t('global.no_result') }} "<strong>{{ search }}</strong>". {{ $t('global.addcombo1') }} <kbd>enter</kbd> {{ $t('global.addcombo2') }}
                       </v-list-item-title>
                     </v-list-item-content>
                   </v-list-item>
                 </template>
        <template v-slot:selection="{ attrs, item, parent, selected }">
                   <v-chip
                     v-if="item === Object(item)"
                     v-bind="attrs"
                     :input-value="selected"
                     label
                   >
                     <span class="pr-2">
                       {{ item.height }}
                     </span>
                     <v-icon
                       small
                       @click="parent.selectItem(item)"
                     >
                       mdi-close
                     </v-icon>
                   </v-chip>
                 </template>
        </v-combobox>
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="mediumSelectItems"
            v-model="item.medium"
            :items="mediumSelectItems"
            :error-messages="mediumErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.material.medium')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.reference"
            :error-messages="referenceErrors"
            :label="$t('profile.reference')"
            required
            @input="$v.item.reference.$touch()"
            @blur="$v.item.reference.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customers"
            :items="customerSelectItems"
            :error-messages="customersErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.customersreserved')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('profile.description')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.descriptionfr"
            :error-messages="descriptionfrErrors"
            :label="$t('profile.descriptionfr')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.descriptionfr.$touch()"
            @blur="$v.item.descriptionfr.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'ProfilefileForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.machineGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.toolheadGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.optionGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.softwareGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.surfaceGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.materialtypeGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.mediumGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.materialmanufacturerGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.customerGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.colorGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.qualityGetSelectItems({'orderCol'  : 'order[height]','order'  : 'asc'});
    this.layerGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
    this.nozzleGetSelectItems({'orderCol'  : 'order[size]','order'  : 'asc'});
    this.nozzleMaterialGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
  },
  data() {
    return {
        name: null,
        namefr: null,
        version: null,
        reference: null,
        public: null,
        experimental: null,
        newRelease: null,
        updateRelease: null,
        file: null,
        machines: null,
        toolheads: null,
        options: null,
        softwares: null,
        surfaces: null,
        materialType: null,
        materialManufacturer: null,
        customers: null,
        medium: null,
        description: null,
        descriptionfr: null,
        colors: null,
        qualities: null,
        layers: null,
        nozzles: null,
        nozzleMaterials: null,
    };
  },
  computed: {
    isLoading() {
      return (
         this.isLoading_machine ||
         this.isLoading_software ||
         this.isLoading_toolhead ||
         this.isLoading_option ||
         this.isLoading_surface ||
         this.isLoading_materialtype ||
         this.isLoading_materialmanufacturer ||
         this.isLoading_medium ||
         this.isLoading_color ||
         this.isLoading_quality ||
         this.isLoading_layer ||
         this.isLoading_nozzle ||
         this.isLoading_nozzlematerial ||
         this.isLoading_customer
       );
    },
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    ...mapFields('softwareversion', {
      softwareSelectItems: 'selectItems',
      isLoading_software : 'isLoading'
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
      isLoading_machine : 'isLoading'
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems',
      isLoading_toolhead : 'isLoading'
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
      isLoading_option : 'isLoading'
    }),
    ...mapFields('printingsurfacematerial', {
      surfaceSelectItems: 'selectItems',
      isLoading_surface : 'isLoading'
    }),
    ...mapFields('materialtype', {
      materialtypeSelectItems: 'selectItems',
      isLoading_materialtype : 'isLoading'
    }),
    ...mapFields('materialmanufacturer', {
      materialmanufacturerSelectItems: 'selectItems',
      isLoading_materialmanufacturer : 'isLoading'
    }),
    ...mapFields('materialmedium', {
      mediumSelectItems: 'selectItems',
      isLoading_medium : 'isLoading'
    }),
    ...mapFields('materialcolor', {
      colorSelectItems: 'selectItems',
      isLoading_color : 'isLoading'
    }),
    ...mapFields('qualityfocus', {
      qualitySelectItems: 'selectItems',
      isLoading_quality : 'isLoading'
    }),
    ...mapFields('qualitylayer', {
      layerSelectItems: 'selectItems',
      isLoading_layer : 'isLoading'
    }),
    ...mapFields('nozzleout', {
      nozzleSelectItems: 'selectItems',
      isLoading_nozzle : 'isLoading'
    }),
    ...mapFields('nozzlematerial', {
      nozzleMaterialSelectItems: 'selectItems',
      isLoading_nozzlematerial : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    versionErrors() {
      const errors = [];
      if (!this.$v.item.version.$dirty) return errors;
      has(this.violations, 'version') && errors.push(this.violations.version);
      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    referenceErrors() {
      const errors = [];
      if (!this.$v.item.reference.$dirty) return errors;
      has(this.violations, 'reference') && errors.push(this.violations.reference);
      !this.$v.item.reference.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      return errors;
    },
    descriptionfrErrors() {
      const errors = [];
      if (!this.$v.item.descriptionfr.$dirty) return errors;
      has(this.violations, 'descriptionfr') && errors.push(this.violations.descriptionfr);
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.item.file.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.file);
      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    experimentalErrors() {
      const errors = [];
      if (!this.$v.item.experimental.$dirty) return errors;
      has(this.violations, 'experimental') && errors.push(this.violations.experimental);
      return errors;
    },
    newReleaseErrors() {
      const errors = [];
      if (!this.$v.item.newRelease.$dirty) return errors;
      has(this.violations, 'newRelease') && errors.push(this.violations.newRelease);
      return errors;
    },
    updateReleaseErrors() {
      const errors = [];
      if (!this.$v.item.updateRelease.$dirty) return errors;
      has(this.violations, 'updateRelease') && errors.push(this.violations.updateRelease);
      return errors;
    },
    machinesErrors() {
      const errors = [];
      if (!this.$v.item.machines.$dirty) return errors;
      has(this.violations, 'machines') && errors.push(this.violations.machines);
    //  !this.$v.item.machines.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    softwaresErrors() {
      const errors = [];
      if (!this.$v.item.softwares.$dirty) return errors;
      has(this.violations, 'softwares') && errors.push(this.violations.softwares);
      return errors;
    },
    materialtypeErrors() {
      const errors = [];
      if (!this.$v.item.materialType.$dirty) return errors;
      has(this.violations, 'materialType') && errors.push(this.violations.materialType);
      !this.$v.item.materialType.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    materialManufacturerErrors() {
      const errors = [];
      if (!this.$v.item.materialManufacturer.$dirty) return errors;
      has(this.violations, 'materialManufacturer') && errors.push(this.violations.materialManufacturer);
      !this.$v.item.materialManufacturer.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    mediumErrors() {
      const errors = [];
      if (!this.$v.item.medium.$dirty) return errors;
      has(this.violations, 'medium') && errors.push(this.violations.medium);
      !this.$v.item.medium.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    toolheadsErrors() {
      const errors = [];
      if (!this.$v.item.toolheads.$dirty) return errors;
      has(this.violations, 'toolheads') && errors.push(this.violations.toolheads);
      return errors;
    },
    optionsErrors() {
      const errors = [];
      if (!this.$v.item.options.$dirty) return errors;
      has(this.violations, 'options') && errors.push(this.violations.options);
      return errors;
    },
    surfacesErrors() {
      const errors = [];
      if (!this.$v.item.surfaces.$dirty) return errors;
      has(this.violations, 'surfaces') && errors.push(this.violations.surfaces);
      return errors;
    },
    colorsErrors() {
      const errors = [];
      if (!this.$v.item.colors.$dirty) return errors;
      has(this.violations, 'colors') && errors.push(this.violations.colors);
      return errors;
    },
    qualitiesErrors() {
      const errors = [];
      if (!this.$v.item.qualities.$dirty) return errors;
      has(this.violations, 'qualities') && errors.push(this.violations.qualities);
      return errors;
    },
    layersErrors() {
      const errors = [];
      if (!this.$v.item.layers.$dirty) return errors;
      has(this.violations, 'layers') && errors.push(this.violations.layers);
      return errors;
    },
    nozzlesErrors() {
      const errors = [];
      if (!this.$v.item.nozzles.$dirty) return errors;
      has(this.violations, 'nozzles') && errors.push(this.violations.nozzles);
      return errors;
    },
    nozzleMaterialsErrors() {
      const errors = [];
      if (!this.$v.item.nozzleMaterials.$dirty) return errors;
      has(this.violations, 'nozzleMaterials') && errors.push(this.violations.nozzleMaterials);
      return errors;
    },
    customersErrors() {
      const errors = [];
      if (!this.$v.item.customers.$dirty) return errors;
      has(this.violations, 'customers') && errors.push(this.violations.customers);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  changeLayer() {
  this.item.layers = this.item.layers
    .filter(v => v !== null && v !== undefined && v !== '') // sécurise
    .map(v => {
      if (typeof v === 'string' || typeof v === 'number') {
        const height = parseFloat(v);
        if (!isNaN(height)) {
          return { height }; // nouvel objet à créer
        }
      } else if (typeof v === 'object') {
        return v;
      }
      return null;
    })
    .filter(v => v !== null); // encore plus de sécurité



},

    ...mapActions({
      softwareGetSelectItems: 'softwareversion/fetchSelectItems'
    }),
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      toolheadGetSelectItems: 'toolhead/fetchSelectItems'
    }),
    ...mapActions({
      optionGetSelectItems: 'option/fetchSelectItems'
    }),
    ...mapActions({
      surfaceGetSelectItems: 'printingsurfacematerial/fetchSelectItems'
    }),
    ...mapActions({
      materialtypeGetSelectItems: 'materialtype/fetchSelectItems'
    }),
    ...mapActions({
      materialmanufacturerGetSelectItems: 'materialmanufacturer/fetchSelectItems'
    }),
    ...mapActions({
      mediumGetSelectItems: 'materialmedium/fetchSelectItems'
    }),
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems'
    }),
    ...mapActions({
      colorGetSelectItems: 'materialcolor/fetchSelectItems'
    }),
    ...mapActions({
      qualityGetSelectItems: 'qualityfocus/fetchSelectItems'
    }),
    ...mapActions({
      layerGetSelectItems: 'qualitylayer/fetchSelectItems'
    }),
    ...mapActions({
      nozzleGetSelectItems: 'nozzleout/fetchSelectItems'
    }),
    ...mapActions({
      nozzleMaterialGetSelectItems: 'nozzlematerial/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      file: {
        maxsizefile : maxsizefile(20),
      },
      version: {
        required,
      },
      name: {
        required,
      },
      namefr: {
        required,
      },
      reference: {
        required,
      },
      description: {
      },
      descriptionfr: {
      },
      public: {
      },
      experimental: {
      },
      newRelease: {
      },
      updateRelease: {
      },
      machines: {
      },
      toolheads: {
      },
      options: {
      },
      softwares: {
      },
      surfaces: {
      },
      colors: {
      },
      qualities: {
      },
      layers: {
      },
      nozzles: {
      },
      nozzleMaterials: {
      },
      materialType: {
        required,
      },
      materialManufacturer: {
        required,
      },
      medium: {
        required,
      },
      customers: {
      },
    }
  }
};
</script>
